import { useState } from "react";
import apiClient from "../utils/apiClient";
import { requestAppRating } from '../utils/requestAppRating';
import { Capacitor } from '@capacitor/core';
import { InAppReview } from '@capacitor-community/in-app-review';

export default function RecipeRating({ recipeId, initialRating, onRated }) {
  const [rating, setRating] = useState(initialRating);

  const submitRating = async (newRating) => {
    setRating(newRating);
    try {
      const res = await apiClient.post(`/recipes/${recipeId}/rate`, { rating: newRating });
      onRated?.(newRating); // notify parent
      
      if (res.data.shouldPrompt) {
        //requestAppRating(); // Show prompt only when backend says so
        if (Capacitor.isNativePlatform()) {
          InAppReview.requestReview();
        }
      }
      
    } catch (err) {
      console.error("Failed to save rating", err);
    }
  };

  return (
    <div className="flex items-center space-x-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          onClick={() => submitRating(star)}
          className={`text-2xl ${star <= rating ? "text-yellow-500" : "text-gray-300"}`}
        >
          ★
        </button>
      ))}
    </div>
  );
}
